import { render, staticRenderFns } from "./AddRoom.vue?vue&type=template&id=1b92e966&scoped=true"
import script from "./AddRoom.vue?vue&type=script&lang=js"
export * from "./AddRoom.vue?vue&type=script&lang=js"
import style0 from "./AddRoom.vue?vue&type=style&index=0&id=1b92e966&prod&lang=scss&scoped=true"
import style1 from "./AddRoom.vue?vue&type=style&index=1&id=1b92e966&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b92e966",
  null
  
)

export default component.exports